export enum ViewType {

    PROJECT_LIST                    = 12,
    PROJECT_TABLE                   = 13,       // PROJECT_TABLE
    PROJECT_BOARD                   = 14,
    PROJECT_GANTT                   = 15,       // Gantt (!)
    PROJECT_INFO                    = 16,
    PROJECT_CALENDAR                = 17,
    PROJECT_FILES                   = 18,
    PROJECT_ACTIVITY                = 19,
    PROJECT_WORKLOAD                = 21,       // Workload
    PROJECT_DOCS                    = 22,
    PROJECT_MEETINGS                = 24,
    PROJECT_EXPENSES                = 25,
    PROJECT_DISCUSSION              = 26,
    PROJECT_GOALS                   = 27,
    PROJECT_PAGE                    = 28,
    PROJECT_LINK                    = 29,
    PROJECT_EMBED                   = 30,
    PROJECT_REPORTS                 = 31,
    PROJECT_SUMMARY                 = 32,
    PROJECT_TIMELINE                = 33,
    PROJECT_WHITEBOARD              = 34,
    PROJECT_EVENTS_SUMMARY          = 35,
    PROJECT_TODOS                   = 36,

    PROJECT_VIEW_FORM               = 50,       // not sure if used but we'll need it
    PROJECT_DASHBOARD               = 51,
    PROJECT_REQUEST_FORMS           = 52,
    PROJECT_NO_VIEWS                = 53,
    PROJECT_TABLE_MAP               = 54,
    PROJECT_EVERYTHING              = 55,

    CUSTOM_VIEW_ACTION_REQUIRED     = 2,    //old name TASKS_PLANNING
    CUSTOM_VIEW_PRIORITIES          = 3,
    CUSTOM_VIEW_TASKS_BY_USER       = 5,
    CUSTOM_VIEW_EVENTS_SUMMARY      = 7,
    CUSTOM_VIEW_WHATS_DONE          = 8,
    CUSTOM_VIEW_PASTDUE             = 10,
    CUSTOM_VIEW_TASKS_TABLE         = 101,  // regular table
    CUSTOM_VIEW_PROJECTS_TABLE      = 102,
    CUSTOM_VIEW_TASKS_LIST          = 104,
    CUSTOM_VIEW_BOARD               = 105,
    CUSTOM_VIEW_GANTT               = 106,
    CUSTOM_VIEW_WORKLOAD            = 107,
    CUSTOM_VIEW_ACTIVITY            = 109,
    CUSTOM_VIEW_CALENDAR            = 110,
    CUSTOM_VIEW_DOCUMENTS           = 118,
    CUSTOM_VIEW_DASHBOARD           = 119,
    CUSTOM_VIEW_EXPENSES            = 122,
    // CUSTOM_VIEW_MAP                 = 123,
    CUSTOM_VIEW_TIMELINE            = 123,
    CUSTOM_VIEW_TODOS               = 124,

    CUSTOM_VIEW_CUSTOM_ENTITY_GLIST = 151,
    CUSTOM_VIEW_CUSTOM_ENTITY_TABLE = 152,
    CUSTOM_VIEW_CUSTOM_ENTITY_BOARD = 153,

    // PROJECTS VIEWS
    PROJECTS_PROJECTS_LIST      = 4,    // all projects (!) - what about custom projects list ?
    PROJECTS_PORTFOLIO          = 23,   // is used for new portfolio in quick add

    PORTFOLIO_SUMMARY           = 301,
    PORTFOLIO_LIST              = 312,
    PORTFOLIO_TABLE             = 313,
    PORTFOLIO_BOARD             = 314,
    PORTFOLIO_GANTT             = 315,
    PORTFOLIO_INFO              = 316,
    PORTFOLIO_CALENDAR          = 317,
    PORTFOLIO_WORKLOAD          = 321,
    // PORTFOLIO_MAP           = 322,

    MY_RECENT                   = 20,
    MY_NOTES                    = 116,
    MY_TASKS_LIST               = 103,
    MY_WORK_CALENDAR            = 111,
    MY_WORK_WORKLOAD            = 108,
    MY_MEETINGS                 = 112, // not in use at the moment
    MY_TIME                     = 113, // my time
    MY_WORK                     = 114,
    NOTIFICATIONS               = 115,
    MY_DOCUMENTS                = 117,
    MY_GOALS                    = 120,
    MY_ATTENDANCE               = 121,

    RESOURCE_PLANNING           = 9, // still used in backend - akkuratno !!! nado razobratsya

    // Time report
    TIME_REPORTING_SUMMARY_V1               = 400,
    REPORT_TIME_REPORT_BY_USER_LEGACY       = 401,
    REPORT_TIME_REPORT_BY_PROJECT_LEGACY    = 402,
    REPORT_TIME_REPORTING_SUMMARY           = 403,
    REPORT_MY_REPORTS                       = 404,
    REPORT_EFFORTS_DISTRIBUTION_BY_USER     = 405,
    REPORT_EFFORTS_DISTRIBUTION_BY_PROJECT  = 406,
    REPORT_TIME_REPORTING_LEGACY            = 407,
    REPORT_PROJECT_WORK_ITEM_REPORT_BY_USER = 408,
    REPORT_PROJECT_WORK_ITEM_REPORT_BY_DATE = 409,

    REPORT_TIME_REPORTS                     = 432,

    //Hr
    REPORT_ATTENDANCE               = 410,
    REPORT_CLOCK_IN                 = 411,
    REPORT_VACATION                 = 412,
    REPORT_DAILY                    = 427,

    //Resource
    REPORT_RESOURCE_ALLOCATION      = 413,
    REPORT_RESOURCE_AVAILABILITY    = 414,

    //Task
    REPORT_TASK_BURN_UP             = 415,
    REPORT_TASK_BURN_DOWN           = 416,
    REPORT_PROJECTS_VELOCITY        = 417,
    REPORT_PROGRESS_REPORT          = 418,
    REPORT_TASK_SUMMARY             = 419,
    REPORT_TASK_SUMMARY_BY_USER     = 420,

    REPORT_TASKS_CATEGORY_CHART     = 428,
    REPORT_TASKS_TIME_CHART         = 430,

    //Communication
    REPORT_PROCESS_FLOWS            = 421,
    REPORT_USERS_COMMUNICATIONS     = 422,
    REPORT_USERS_COLLABORATIONS     = 423,

    //Behavior

    REPORT_SELF_ORGANIZATION        = 424,
    REPORT_SELF_PLANNING            = 425,
    REPORT_AVG_RESPONSE_TIME        = 426,
    REPORT_TIME_ENTRIES             = 429,

    REPORT_TASKS_LIFECYCLE          = 431,

    // Custom reports
    REPORT_APP_ZEN_IMPLEMENTATION_DASHBOARD = 500,


    // My work views
    MY_WORK_VIEW_TYPE               = 600,
    MY_WORK_VIEW_DAY                = 601,
    MY_WORK_VIEW_SPLIT              = 602,
    MY_WORK_VIEW_BOARD              = 603,
    MY_WORK_VIEW_CALENDAR           = 604,
    MY_WORK_VIEW_UPCOMING           = 605,
    MY_WORK_VIEW_PROJECT            = 606,
    MY_WORK_VIEW_FROM_USER          = 607,
    MY_WORK_VIEW_PRIORITY           = 608,

    // My tasks views
    MY_TASKS_LIST_ACTION_REQUIRED   = 609,
    MY_TASKS_LIST_ASSIGNED_TO_ME    = 610,
    MY_TASKS_LIST_ALL_INVOLVED      = 611,
    MY_TASKS_LIST_CREATED_BY_ME     = 612,
    MY_TASKS_LIST_SOMEDAY           = 613,
    MY_TASKS_LIST_PASTDUE           = 614,
    MY_TASKS_LIST_HIGH_PRIORITY     = 615,
}


// table based views
export const TABLE_VIEWS = [
    ViewType.PROJECT_SUMMARY,
    ViewType.PROJECT_TABLE,
    ViewType.PROJECT_GANTT,

    ViewType.PORTFOLIO_SUMMARY,
    ViewType.PORTFOLIO_TABLE,
    ViewType.PORTFOLIO_GANTT,

    ViewType.CUSTOM_VIEW_TASKS_TABLE,
    ViewType.CUSTOM_VIEW_PROJECTS_TABLE,
    ViewType.CUSTOM_VIEW_GANTT,

    ViewType.PROJECTS_PORTFOLIO,
]

export const LIST_VIEWS = [
    ViewType.PROJECT_LIST,

    ViewType.PORTFOLIO_LIST,

    ViewType.CUSTOM_VIEW_TASKS_LIST,
]

export const TAG_VIEW_TYPES: ViewType[] = [
    ViewType.PROJECT_LIST,
    ViewType.PROJECT_TABLE,
    ViewType.PROJECT_BOARD
]

export const PROJECT_VIEW_TYPES: ViewType[] = [
    ViewType.PROJECT_DISCUSSION,
    ViewType.PROJECT_LIST,
    ViewType.PROJECT_TABLE,
    ViewType.PROJECT_BOARD,
    ViewType.PROJECT_GANTT,
    ViewType.PROJECT_WORKLOAD,
    ViewType.PROJECT_TIMELINE,
    ViewType.PROJECT_CALENDAR,

    ViewType.PROJECT_DASHBOARD,
    ViewType.PROJECT_FILES,
    ViewType.PROJECT_DOCS,
    ViewType.PROJECT_MEETINGS,
    ViewType.PROJECT_ACTIVITY,
    ViewType.PROJECT_EXPENSES,
    ViewType.PROJECT_GOALS,

    ViewType.PROJECT_REQUEST_FORMS,
    ViewType.PROJECT_PAGE,
    ViewType.PROJECT_WHITEBOARD,
    ViewType.PROJECT_LINK,
    ViewType.PROJECT_EMBED,
    ViewType.PROJECT_REPORTS,
]

export const REPORT_VIEW_TYPES = [
    ViewType.TIME_REPORTING_SUMMARY_V1,
    ViewType.REPORT_TIME_REPORT_BY_USER_LEGACY,
    ViewType.REPORT_TIME_REPORTS,
    ViewType.REPORT_TIME_REPORTING_SUMMARY,
    ViewType.REPORT_MY_REPORTS,
    ViewType.REPORT_EFFORTS_DISTRIBUTION_BY_USER,
    ViewType.REPORT_EFFORTS_DISTRIBUTION_BY_PROJECT,
    ViewType.REPORT_PROJECT_WORK_ITEM_REPORT_BY_USER,
    ViewType.REPORT_PROJECT_WORK_ITEM_REPORT_BY_DATE,
    ViewType.REPORT_ATTENDANCE,
    ViewType.REPORT_CLOCK_IN,
    ViewType.REPORT_VACATION,
    ViewType.REPORT_RESOURCE_ALLOCATION,
    ViewType.REPORT_RESOURCE_AVAILABILITY,
    ViewType.REPORT_TASK_BURN_UP,
    ViewType.REPORT_TASK_BURN_DOWN,
    ViewType.REPORT_PROJECTS_VELOCITY,
    ViewType.REPORT_PROGRESS_REPORT,
    ViewType.REPORT_TASK_SUMMARY,
    ViewType.REPORT_TASK_SUMMARY_BY_USER,
    ViewType.REPORT_PROCESS_FLOWS,
    ViewType.REPORT_USERS_COMMUNICATIONS,
    ViewType.REPORT_USERS_COLLABORATIONS,
    ViewType.REPORT_SELF_ORGANIZATION,
    ViewType.REPORT_SELF_PLANNING,
    ViewType.REPORT_AVG_RESPONSE_TIME,
]

export const PERSONAL_VIEW_TYPES = [
    ViewType.MY_TIME,
    ViewType.MY_WORK,
    ViewType.MY_WORK_CALENDAR,
    ViewType.MY_NOTES,
    ViewType.NOTIFICATIONS,
    ViewType.MY_WORK_WORKLOAD,
    ViewType.MY_ATTENDANCE,
    ViewType.MY_GOALS,
    ViewType.MY_RECENT,
    ViewType.MY_TASKS_LIST,
    ViewType.MY_DOCUMENTS,
    ViewType.MY_MEETINGS,
]
